<template lang="pug">
  div
    .band 
      .container
        h1.font-size-x-large Documentos Internos
    .container.target
      .row
        .col-xs-12.col-xm-6.col-l-4
          .card
            h1.font-size-large Reglamento interno
            .row.main-center
              .col-xs
                a(href="https://intranet.cima.com.pe/intranetcima/documentos/REGLAMENTOINTERNO2018.pdf" target="_blank").btn--warning.is-active
                  span.icon-file-text
                  span Ver
        .col-xs-12.col-xm-6.col-l-4
          .card
            h1.font-size-large Plan curricular
            .row.main-center
              .col-xs
                a(href="https://intranet.cima.com.pe/intranetcima/documentos/PLANCURRICULAR2018.pdf" target="_blank").btn--warning.is-active
                  span.icon-file-text
                  span Ver
        .col-xs-12.col-xm-6.col-l-4
          .card
            h1.font-size-large Plan de convivencia
            .row.main-center
              .col-xs
                a(href="https://intranet.cima.com.pe/intranetcima/documentos/PLANTRABAJO2018.pdf" target="_blank").btn--warning.is-active
                  span.icon-file-text
                  span Ver

</template>

<script>
export default {

}
</script>



// WEBPACK FOOTER //
// src/components/Regulation.vue